<template>
	<div class="ss-content ss-activity-detail">
		<div class="article-box">
			<div class="ss-container">
				<div class="article__left ss-container__left">
					<p class="article__title">{{articleData.title}}</p>
					<div class="article__time">
						<div class="fr" v-if="showTools">
							<div class="operation-icon operation-icon__collection" @click="collection()" :class="{active: toolObj.isCollect}"></div>
							<div class="operation-icon operation-icon__dianzan" @click="resourceUp()" :class="{active: toolObj.isUp}"></div>
							<a class="operation-icon operation-icon__pinglun" href="#commentBox">{{toolObj.comments | unit}}</a>
						</div>
						<span>{{articleData.releaseTimestamp | time}}</span>
						<span v-if="articleData.contentExt && articleData.contentExt.contentSource">来源: {{articleData.contentExt.contentSource.sourceName}}</span>
					</div>
					<div class="article__html" v-html="articleData.txt"></div>
					<div class="comment-box" id="commentBox" v-if="isAllow">
						<ssCommentList />
					</div>
				</div>
				<div class="ss-container__right" v-if="showRecmd">
					<ssRecmdList title="为你推荐" bgColor="#F4F5F6" showRefresh />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import ssCommentList from '@/components/ss-comment-list/ss-comment-list.vue'
	import articleDetailMixin from '@/mixins/articleDetail.js'
	export default {
		mixins: [ articleDetailMixin ],
		name: 'culturalInfoDetail',
		components: {
			ssCommentList
		}
	}
</script>

<style lang="scss" scoped="scoped">
	@import '~@/assets/css/article-detail.scss';
</style>
